import { FormControl, FormControlProps } from '@mui/material';

import { ReactNode } from 'react';

type BaseWrapperProps = FormControlProps & {
  children: ReactNode;
};

export const BaseWrapper: React.FC<BaseWrapperProps> = ({
  children,
  sx,
  ...rest
}) => {
  return (
    <FormControl
      sx={{
        padding: 0.8,
        ...sx
      }}
      {...rest}
    >
      {children}
    </FormControl>
  );
};

type FieldWrapperProps = FormControlProps & {
  children: React.ReactNode;
};

export const FieldWrapper: React.FC<FieldWrapperProps> = ({
  children,
  sx,
  ...rest
}) => {
  return (
    <BaseWrapper
      sx={{
        borderRadius: 1,
        ...sx
      }}
      {...rest}
    >
      {children}
    </BaseWrapper>
  );
};
